// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_hw-0";
export var discountCodeInput = "_hw-1";